import {getParentStructurePath} from '../../Common/PropertyPaths';

export const generateBurnDegreeDetails = (parentPath: string) => {
  return Array.from({length: 2}, (_, index) => ({
    burnSize1Amount: `${parentPath}.burnDetails.burnDegreeDetails[${index}].burnSize1Amount`,
    burnSize2Amount: `${parentPath}.burnDetails.burnDegreeDetails[${index}].burnSize2Amount`,
  }));
};

export const accidentInjuriesPath = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = getParentStructurePath(planIndex, coverageIndex);
  return {
    unitsOfAccidentInjuries: `${parentPath}.unitsOfAccidentInjuries`,
    schedule: `${parentPath}.scheduleOfBenefitEnhancementRider`,
    isBrainInjuryDiagnosisApplied: `${parentPath}.isBrainInjuryDiagnosisApplied`,
    isBrokenToothApplied: `${parentPath}.isBrokenToothApplied`,
    isBurnApplied: `${parentPath}.isBurnApplied`,
    isBurnSkinGraftApplied: `${parentPath}.isBurnSkinGraftApplied`,
    isComaApplied: `${parentPath}.isComaApplied`,
    isLacerationApplied: `${parentPath}.isLacerationApplied`,
    isParalysisApplied: `${parentPath}.isParalysisApplied`,
    isPunctureWoundApplied: `${parentPath}.isPunctureWoundApplied`,
    isGunshotWoundApplied: `${parentPath}.isGunshotWoundApplied`,

    brainInjuryDiagnosisDetails: {
      incurralPeriod: `${parentPath}.brainInjuryDiagnosisDetails.incurralPeriod`,
      customizeBenefitAmount: `${parentPath}.brainInjuryDiagnosisDetails.customizeBenefitAmount`,
      benefitAmount: `${parentPath}.brainInjuryDiagnosisDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.brainInjuryDiagnosisDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.brainInjuryDiagnosisDetails.timePeriodCd`,
    },

    brokenToothDetails: {
      incurralPeriod: `${parentPath}.brokenToothDetails.incurralPeriod`,
      customizeBenefitAmount: `${parentPath}.brokenToothDetails.customizeBenefitAmount`,
      benefitAmount: `${parentPath}.brokenToothDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.brokenToothDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.brokenToothDetails.timePeriodCd`,
    },

    burnDetails: {
      incurralPeriod: `${parentPath}.burnDetails.incurralPeriod`,
      customizeBenefitAmount: `${parentPath}.burnDetails.customizeBenefitAmount`,
      burnDegreeDetails: [
        //second degree burn
        {
          burnSize1Amount: `${parentPath}.burnDetails.burnDegreeDetails[0].burnSize1Amount.amount`,
          burnSize2Amount: `${parentPath}.burnDetails.burnDegreeDetails[0].burnSize2Amount.amount`,
          burnSize3Amount: `${parentPath}.burnDetails.burnDegreeDetails[0].burnSize3Amount.amount`,
        },
        //third degree burn
        {
          burnSize1Amount: `${parentPath}.burnDetails.burnDegreeDetails[1].burnSize1Amount.amount`,
          burnSize2Amount: `${parentPath}.burnDetails.burnDegreeDetails[1].burnSize2Amount.amount`,
          burnSize3Amount: `${parentPath}.burnDetails.burnDegreeDetails[1].burnSize3Amount.amount`,
        },
      ],
      maxBenefitNumber: `${parentPath}.burnDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.burnDetails.timePeriodCd`,
    },

    comaDetails: {
      incurralPeriod: `${parentPath}.comaDetails.incurralPeriod`,
      waitingPeriod: `${parentPath}.comaDetails.waitingPeriod`,
      customizeBenefitAmount: `${parentPath}.comaDetails.customizeBenefitAmount`,
      benefitAmount: `${parentPath}.comaDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.comaDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.comaDetails.timePeriodCd`,
    },

    burnSkinGraftDetails: {
      incurralPeriod: `${parentPath}.burnSkinGraftDetails.incurralPeriod`,
      burnsBenefitPct: `${parentPath}.burnSkinGraftDetails.burnsBenefitPct`,
      maxBenefitNumber: `${parentPath}.burnSkinGraftDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.burnSkinGraftDetails.timePeriodCd`,
    },

    lacerationDetails: {
      incurralPeriod: `${parentPath}.lacerationDetails.incurralPeriod`,
      customizeBenefitAmount: `${parentPath}.lacerationDetails.customizeBenefitAmount`,
      withoutRepairAmount: `${parentPath}.lacerationDetails.withoutRepairAmount.amount`,
      withRepairAmount: `${parentPath}.lacerationDetails.withRepairAmount.amount`,
      lacerationLength1Amount: `${parentPath}.lacerationDetails.lacerationLength1Amount.amount`,
      lacerationLength2Amount: `${parentPath}.lacerationDetails.lacerationLength2Amount.amount`,
      lacerationLength3Amount: `${parentPath}.lacerationDetails.lacerationLength3Amount.amount`,
      maxBenefitNumber: `${parentPath}.lacerationDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.lacerationDetails.timePeriodCd`,
      benefitAmount: `${parentPath}.lacerationDetails.benefitAmount.amount`,
    },

    paralysisDetails: {
      incurralPeriod: `${parentPath}.paralysisDetails.incurralPeriod`,
      minimumDuration: `${parentPath}.paralysisDetails.minimumDuration`,
      customizeBenefitAmount: `${parentPath}.paralysisDetails.customizeBenefitAmount`,
      oneOrTwoLimbsAmount: `${parentPath}.paralysisDetails.oneOrTwoLimbsAmount.amount`,
      threeOrFourLimbsAmount: `${parentPath}.paralysisDetails.threeOrFourLimbsAmount.amount`,
      maxBenefitNumber: `${parentPath}.paralysisDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.paralysisDetails.timePeriodCd`,
    },

    punctureWoundDetails: {
      incurralPeriod: `${parentPath}.punctureWoundDetails.incurralPeriod`,
      customizeBenefitAmount: `${parentPath}.punctureWoundDetails.customizeBenefitAmount`,
      benefitAmount: `${parentPath}.punctureWoundDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.punctureWoundDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.punctureWoundDetails.timePeriodCd`,
      details: `${parentPath}.punctureWoundDetails`,
    },

    gunshotWoundDetails: {
      incurralPeriod: `${parentPath}.gunshotWoundDetails.incurralPeriod`,
      customizeBenefitAmount: `${parentPath}.gunshotWoundDetails.customizeBenefitAmount`,
      benefitAmount: `${parentPath}.gunshotWoundDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.gunshotWoundDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.gunshotWoundDetails.timePeriodCd`,
      details: `${parentPath}.gunshotWoundDetails`,
    },
  };
};
